import React, { createContext, useContext, useState } from 'react';

// Crear el contexto
const LayoutContext = createContext();

// Proveedor del contexto
export const LayoutProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('Exporta Fácil');

  return (
    <LayoutContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </LayoutContext.Provider>
  );
};

// Hook personalizado para usar el contexto
export const usePageTitle = () => {
  return useContext(LayoutContext);
};
